module.exports = __webpack_public_path__ + "img/airvey-watermark.fe16bef8.png";